module.exports = __webpack_public_path__ + "e05c1812fc718452213e64d37e4d1692.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/glasses-square-s.png
// module id = 2345
// module chunks = 0